import {
    CREATE_PLAY_QUERY_SUCCESS,
    CREATE_PLAY_QUERY_ERROR,
    CREATE_PLAY_QUERY_REQUEST,
    CREATE_PLAY_QUERY_OPTIONS_SUCCESS,
    CREATE_PLAY_QUERY_OPTIONS_ERROR,
    CREATE_PLAY_QUERY_OPTIONS_REQUEST,
    CREATE_PLAY_QUERY_FOLDERS_SUCCESS,
    CREATE_PLAY_QUERY_FOLDERS_ERROR,
    CREATE_PLAY_QUERY_FOLDERS_REQUEST,
    CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_SUCCESS,
    CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_ERROR,
    CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_REQUEST,
    CREATE_PLAY_QUERY_DATA_LIBRARY_SUCCESS,
    CREATE_PLAY_QUERY_DATA_LIBRARY_ERROR,
    CREATE_PLAY_QUERY_DATA_LIBRARY_REQUEST,
    CREATE_PLAY_QUERY_STREAM,
    CREATE_PLAY_QUERY_STOP_LOADER,
} from '../../Types/user/Types';

import {
    createPlay_ConversationApi,
    getPlay_QueryOptionsAPI,
    getPlay_QueryFoldersAPI,
    getPlay_QuerySupportingFoldersAPI,
    createPlay_QUeryLibraryApi,
} from '../../Apis/user/ApiConfig';
import { id } from 'date-fns/locale';

// for conversation .............
export const create_play_query_success = (res) => {
    return {
        type: CREATE_PLAY_QUERY_SUCCESS,
        payload: res,
    };
};
export const create_play_query_stream = (res) => {
    return {
        type: CREATE_PLAY_QUERY_STREAM,
        payload: res,
    };
};
export const create_play_query_error = (error) => {
    return {
        type: CREATE_PLAY_QUERY_ERROR,
        error: error,
    };
};
export const create_play_query_request = (res) => {
    return {
        type: CREATE_PLAY_QUERY_REQUEST,
        payload: res,
    };
};
export const create_play_query_stop_loader = (res) => {
    return {
        type: CREATE_PLAY_QUERY_STOP_LOADER,
        payload: res,
    };
};
// for workspace option ........
export const create_play_query_options_success = (res) => {
    return {
        type: CREATE_PLAY_QUERY_OPTIONS_SUCCESS,
        payload: res,
    };
};
export const create_play_query_options_error = (error) => {
    return {
        type: CREATE_PLAY_QUERY_OPTIONS_ERROR,
        error: error,
    };
};
export const create_play_query_options_request = (res) => {
    return {
        type: CREATE_PLAY_QUERY_OPTIONS_REQUEST,
        payload: res,
    };
};

// for folders ...........
export const create_play_query_folders_success = (res) => {
    return {
        type: CREATE_PLAY_QUERY_FOLDERS_SUCCESS,
        payload: res,
    };
};
export const create_play_query_folders_error = (error) => {
    return {
        type: CREATE_PLAY_QUERY_FOLDERS_ERROR,
        error: error,
    };
};
export const create_play_query_folders_request = (res) => {
    return {
        type: CREATE_PLAY_QUERY_FOLDERS_REQUEST,
        payload: res,
    };
};

// for supporting folders ............
export const create_play_query_supporting_folders_success = (res) => {
    return {
        type: CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_SUCCESS,
        payload: res,
    };
};
export const create_play_query_supporting_folders_error = (error) => {
    return {
        type: CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_ERROR,
        error: error,
    };
};
export const create_play_query_supporting_folders_request = (res) => {
    return {
        type: CREATE_PLAY_QUERY_SUPPORTING_FOLDERS_REQUEST,
        payload: res,
    };
};

//   for library............

export const create_play_query_library_success = (res) => {
    return {
        type: CREATE_PLAY_QUERY_DATA_LIBRARY_SUCCESS,
        payload: res,
    };
};
export const create_play_query_library_error = (error) => {
    return {
        type: CREATE_PLAY_QUERY_DATA_LIBRARY_ERROR,
        error: error,
    };
};
export const create_play_query_library_request = (res) => {
    return {
        type: CREATE_PLAY_QUERY_DATA_LIBRARY_REQUEST,
        payload: res,
    };
};

export const create_play_query_actionHandler = (data, Navigate) => {
    return (dispatch) => {
        dispatch(create_play_query_request());
        try {
            createPlay_ConversationApi(data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(create_play_query_success(res?.data));
                            if (data.message != '' && data.message != null) {
                                dispatch(create_play_query_stream(true));
                            } else {
                                dispatch(create_play_query_stop_loader(false));
                            }
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(create_play_query_error(res));
                        }
                    } else {
                        dispatch(create_play_query_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        create_play_query_error('Something Went Wrong!!!')
                    );
                });
        } catch (err) {
            dispatch(create_play_query_error(err));
        }
    };
};

export const create_play_query_options_actionHandler = (data, Navigate) => {
    return (dispatch) => {
        dispatch(create_play_query_options_request());
        try {
            getPlay_QueryOptionsAPI()
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(
                                create_play_query_options_success(res?.data)
                            );
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(create_play_query_options_error(res));
                        }
                    } else {
                        dispatch(create_play_query_options_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        create_play_query_options_error(
                            'Something Went Wrong!!!'
                        )
                    );
                });
        } catch (err) {
            dispatch(create_play_query_options_error(err));
        }
    };
};

export const create_play_query_folders_actionHandler = (data, selectedFolder, page) => {
    return (dispatch) => {
        dispatch(create_play_query_folders_request());
        try {
            getPlay_QueryFoldersAPI(data)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(
                                create_play_query_folders_success(res?.data)
                            );
                            if (selectedFolder && res?.data?.data?.[0]?.id && data && page) {
                                dispatch(
                                    create_play_query_supporting_folders_actionHandler(
                                        res?.data?.data?.[0]?.id,
                                        data,
                                        page
                                    )
                                );
                            }
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(create_play_query_folders_error(res));
                        }
                    } else {
                        dispatch(create_play_query_folders_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        create_play_query_folders_error(
                            'Something Went Wrong!!!'
                        )
                    );
                });
        } catch (err) {
            dispatch(create_play_query_folders_error(err));
        }
    };
};

export const create_play_query_supporting_folders_actionHandler = (
    data,
    selectedFolderId,
    page
) => {
    return (dispatch) => {
        dispatch(create_play_query_supporting_folders_request(page));
        try {
            getPlay_QuerySupportingFoldersAPI(data, selectedFolderId, page)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(
                                create_play_query_supporting_folders_success(
                                    res?.data
                                )
                            );
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(
                                create_play_query_supporting_folders_error(res)
                            );
                        }
                    } else {
                        dispatch(
                            create_play_query_supporting_folders_error('')
                        );
                    }
                })
                .catch((err) => {
                    dispatch(
                        create_play_query_supporting_folders_error(
                            'Something Went Wrong!!!'
                        )
                    );
                });
        } catch (err) {
            dispatch(create_play_query_supporting_folders_error(err));
        }
    };
};

export const create_play_query_library_actionHandler = (
    data,
    selectedFolderId
) => {
    return (dispatch) => {
        dispatch(create_play_query_library_request());
        try {
            createPlay_QUeryLibraryApi(data, selectedFolderId)
                .then((res) => {
                    if (res) {
                        if (res && res?.data && res?.status === 200) {
                            dispatch(
                                create_play_query_library_success(res?.data)
                            );
                        } else {
                            let data = res?.response?.data?.data;
                            dispatch(create_play_query_library_error(res));
                        }
                    } else {
                        dispatch(create_play_query_library_error(''));
                    }
                })
                .catch((err) => {
                    dispatch(
                        create_play_query_library_error(
                            'Something Went Wrong!!!'
                        )
                    );
                });
        } catch (err) {
            dispatch(create_play_query_library_error(err));
        }
    };
};
